var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedulerEnable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.7 10",
    style: {
      enableBackground: "new 0 0 18.7 10"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7A7A7A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,0.6c-1.1,0-2,0.4-2.8,1H3.5C1.8,1.6,0.4,3.1,0.4,5s1.4,3.4,3.1,3.4h7.6c0.8,0.6,1.7,1,2.8,1 c2.4,0,4.4-2,4.4-4.4C18.3,2.6,16.3,0.6,13.9,0.6z M1.4,5c0-1.3,0.9-2.4,2.1-2.4h6.7C9.8,3.3,9.5,4.1,9.5,5s0.3,1.7,0.7,2.4H3.5 C2.3,7.4,1.4,6.3,1.4,5z M16.8,3.6c-0.7,0.6-3.4,3.2-3.4,3.2l-0.5,0.5h-0.1l-2-2.5c-0.2-0.3-0.2-0.8,0.1-1c0.3-0.2,0.8-0.2,1,0.1 l1,1.3c0.8-0.8,2.3-2.3,2.9-2.8c0.3-0.3,0.7-0.2,1,0.1C17.1,2.9,17.1,3.4,16.8,3.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerEnable);
export default __webpack_public_path__ + "static/media/Scheduler-Enable.07d674e1ad85a9982fc9810d967a9548.svg";
export { ForwardRef as ReactComponent };